import React from "react";
import {BrandName, SupportMail, WebApp} from "../../../constants";
import {InlineLink, Paragraph, Title, Underline, useTermsText} from "../TermsText";

const MessagingTermsSection = () => {
  const {openLink, navigation} = useTermsText();

  return (
    <>
      <Title>{"21. Promotions and Promotion Periods."}</Title>

      <Paragraph>
        <Underline>{"New Player Promotion."}</Underline>{" New players receive “10 Free Shots” which are the equivalent of 10 Challenges with a $3 Challenge Fee, without deposit required. The results of each challenge during the “10 Free Shots” will be accumulated into Free Play with a 1x Turnover requirement. In the case that a New Player does not earn at least $10, the New Player will receive $10 in Free Play after the completion of their 10th Challenge"}
      </Paragraph>

      <Paragraph variant="primary">{"Messaging Terms & Conditions"}</Paragraph>

      <Title>{"General"}</Title>

      <Paragraph>{"When you opt-in to the service, we will send you a message to confirm your signup."}</Paragraph>

      <Paragraph>
        {"By opting into messages, you agree to receive recurring automated marketing and informational text messages from "}{BrandName}{" Team. Automated messages may be sent using an automatic telephone dialing system to the mobile telephone number you provided when signing up or any other number that you designate."}
      </Paragraph>

      <Paragraph>
        {"Message frequency varies, and additional mobile messages may be sent periodically based on your interaction with "}{BrandName}{" Team. "}{BrandName}{" Team reserves the right to alter the frequency of messages sent at any time to increase or decrease the total number of sent messages. "}{BrandName}{" Team also reserves the right to change the short code or phone number or alphanumeric sender where messages are sent"}
      </Paragraph>

      <Paragraph>
        {"Your usual message and data rates may apply. If you have any questions about your text plan or data plan, it is best to contact your mobile provider. Your mobile provider is not liable for delayed or undelivered messages."}
      </Paragraph>

      <Paragraph>{"Your consent to receive marketing messages is not a condition of purchase."}</Paragraph>

      <Title>{"Carriers"}</Title>

      <Paragraph>{"Carriers are not liable for delayed or undelivered messages."}</Paragraph>

      <Title>{"Cancellation"}</Title>

      <Paragraph>
        {"Messages will provide instructions to unsubscribe either by texting STOP or through an included link. After you unsubscribe, we will send you a message to confirm that you have been unsubscribed and no more messages will be sent. If you would like to receive messages from "}{BrandName}{" Team again, just sign up as you did the first time and "}{BrandName}{" Team will start sending messages to you again."}
      </Paragraph>

      <Title>{"Info"}</Title>

      <Paragraph>
        {"For support regarding our services, email us at "}<InlineLink
        onPress={() => openLink(`mailto:${SupportMail}`)}>{SupportMail}</InlineLink>{" or, if supported, text \"HELP\" to +17025214577 at any time and we will respond with instructions on how to unsubscribe. If we include a link in messages we send you from "}{BrandName}{" Team, you may also access instructions on how to unsubscribe and our company information by following that link."}
      </Paragraph>

      <Title>{"Transfer of Number"}</Title>

      <Paragraph>
        {"You agree that before changing your mobile number or transferring your mobile number to another individual, you will either reply \"STOP\" from the original number or notify us of your old number at "}<InlineLink
        onPress={() => openLink(`mailto:${SupportMail}`)}>{SupportMail}</InlineLink>{". The duty to inform us based on the above events is a condition of using this service to receive messages."}
      </Paragraph>

      <Title>{"Privacy"}</Title>

      <Paragraph>
        {"If you have any questions about your data or our privacy practices, please visit our "}<InlineLink
        onPress={() => navigation.navigate('PrivacyPolicy')}>{WebApp}{"/privacy"}</InlineLink>{"."}
      </Paragraph>

      <Title>{"Messaging Terms Changes"}</Title>

      <Paragraph noMargin>
        {"We reserve the right to change or terminate our messaging program at any time. We also reserve the right to update these Messaging Terms at any time. Such changes will be effective immediately upon posting. If you do not agree to a change to these Messaging Terms, you should cancel your enrolment with our messaging program. Your continued enrollment following such changes shall constitute your acceptance of such changes."}
      </Paragraph>
    </>
  );
};

export default React.memo(MessagingTermsSection);
